export const chf = (n) => (n == null || isNaN(n) ? "—" : `${Number(n).toFixed(2)} CHF`);
export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "" : d.toLocaleDateString("fr-CH", { day: "2-digit", month: "short", year: "numeric" });
};
export const fmtTime = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d.toLocaleTimeString("fr-CH", { hour: "2-digit", minute: "2-digit" });
};
